import React, { useMemo } from "react"

import classNames from "classnames"
import PropTypes from "prop-types"

import { InternalExternalLink } from "../InternalExternalLink"
import * as styles from "./Label.module.scss"

const Label = ({ children, onClick, to, className, ...props }) => {
  const cls = classNames(styles.label, className)

  const tagType = useMemo(() => {
    if (to) {
      return "link"
    }

    if (onClick) {
      return "button"
    }

    return "normal"
  }, [onClick, to])

  if (tagType === "button") {
    return (
      <button onClick={onClick} className={cls} {...props}>
        {children}
      </button>
    )
  }

  if (tagType === "link") {
    return (
      <InternalExternalLink to={to.trim()} className={cls} {...props}>
        {children}
      </InternalExternalLink>
    )
  }

  return (
    <span className={cls} {...props}>
      {children}
    </span>
  )
}

Label.propTypes = {
  children: PropTypes.string,
}

export { Label }
